import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LessonIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Lesson",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.62 2H7.38C5.3 2 3.61 3.69 3.61 5.77v20.46C3.61 28.31 5.3 30 7.38 30h17.23c2.08 0 3.77-1.69 3.77-3.77V5.77c0-2.08-1.69-3.77-3.77-3.77Zm-1.08 24.23H8.46c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h15.08c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08m0-6.1H8.46c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h15.08c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08m0-6.11H8.46c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h15.08c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08m0-6.11H8.46c-.59 0-1.08-.48-1.08-1.08s.48-1.08 1.08-1.08h15.08c.59 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08"
    })
  }));
};